<script lang="ts">
  import type { ErrorEntry } from '$lib/stores/errors.svelte';

  let { entry, ondismiss }: { entry: ErrorEntry; ondismiss: () => void } = $props();
</script>

<div class="toast" role="alert">
  <div class="toast__head">
    <div class="toast__body">
      <div class="toast__message">{entry.message}</div>
      {#if entry.context}
        <div class="toast__context">{entry.context}</div>
      {/if}
    </div>
    <button class="toast__close" onclick={ondismiss} aria-label="Dismiss">&times;</button>
  </div>
  {#if entry.code || entry.field || entry.nodeId || entry.portId}
    <div class="toast__chips">
      {#if entry.code}<span class="toast__chip">code: {entry.code}</span>{/if}
      {#if entry.field}<span class="toast__chip">field: {entry.field}</span>{/if}
      {#if entry.nodeId}<span class="toast__chip">node: {entry.nodeId}</span>{/if}
      {#if entry.portId}<span class="toast__chip">port: {entry.portId}</span>{/if}
    </div>
  {/if}
  {#if entry.trace.length > 0}
    <ol class="toast__trace">
      {#each entry.trace as frame}
        <li>
          {#if frame.depth !== undefined && frame.depth !== null}
            <span class="trace__layer">L{frame.depth}</span>
          {/if}
          {#if frame.spaceTitle}
            <span class="trace__space">{frame.spaceTitle}</span>
          {/if}
          {#if frame.nodeTitle || frame.nodeId}
            <span class="trace__node">{frame.nodeTitle ?? frame.nodeId}</span>
          {/if}
          {#if frame.runtime}
            <span class="trace__runtime">{frame.runtime}</span>
          {/if}
        </li>
      {/each}
    </ol>
  {/if}
</div>

<style>
  .toast {
    background: var(--bg-secondary);
    border: 1px solid var(--accent-error);
    border-left-width: 4px;
    border-radius: var(--radius-md);
    padding: var(--sp-2) var(--sp-3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    color: var(--text-primary);
    font-size: var(--fs-sm);
    min-width: 320px;
    max-width: 480px;
  }
  .toast__head {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--sp-3);
    margin-bottom: var(--sp-1);
  }
  .toast__body {
    min-width: 0;
  }
  .toast__context {
    color: var(--text-secondary);
    font-size: var(--fs-xs);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: var(--sp-1);
  }
  .toast__close {
    background: transparent;
    border: none;
    color: var(--text-secondary);
    font-size: var(--fs-lg);
    line-height: 1;
    cursor: pointer;
    padding: 0;
    margin-left: auto;
  }
  .toast__close:hover { color: var(--text-primary); }
  .toast__message {
    font-family: var(--font-mono);
    font-size: var(--fs-base);
    font-weight: 600;
    word-break: break-word;
  }
  .toast__chips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--sp-1);
    margin-top: var(--sp-2);
  }
  .toast__chip {
    padding: 1px 5px;
    border: 1px solid var(--border-node);
    border-radius: var(--radius-sm);
    color: var(--text-secondary);
    background: var(--bg-primary);
    font-family: var(--font-mono);
    font-size: var(--fs-xs);
  }
  .toast__trace {
    margin: var(--sp-2) 0 0;
    padding-left: var(--sp-4);
    color: var(--text-secondary);
    font-size: var(--fs-xs);
    list-style: decimal;
  }
  .toast__trace li { margin-bottom: 2px; }
  .trace__layer {
    color: var(--accent-data);
    font-family: var(--font-mono);
    margin-right: var(--sp-1);
  }
  .trace__space { color: var(--text-primary); margin-right: var(--sp-1); }
  .trace__node { color: var(--text-primary); margin-right: var(--sp-1); font-weight: 500; }
  .trace__runtime {
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 10px;
  }
</style>